import script from "./LocationsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./LocationsTable.vue?vue&type=script&setup=true&lang=js"

import "./LocationsTable.vue?vue&type=style&index=0&id=3656610a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3656610a"]])

export default __exports__